import { MicroFrontendLoaderProps } from './types';

interface LoaderUIProps extends Pick<MicroFrontendLoaderProps, 'isWidgetMode'> {
    error: string | null;
    isLoaded: boolean;
    loadingStep?: string;
}

export const LoaderUI = ({ error, isLoaded, isWidgetMode, loadingStep }: LoaderUIProps) => {
    if (!isWidgetMode) {
        return (
            <>
                {error && (
                    <div className='bg-red-50 fixed bottom-4 right-4 z-50 max-w-md rounded-md p-4 shadow-lg'>
                        <div className='flex'>
                            <div className='text-red-700 text-sm'>
                                <p className='font-bold'>Error loading micro-frontend</p>
                                <p>{error}</p>
                                <div className='mt-2'>
                                    <p className='font-semibold'>Debug info:</p>
                                    <p>Container exists: {document.getElementById('product-provided-container') ? 'Yes' : 'No'}</p>
                                    <p>Mode: {isWidgetMode ? 'Widget' : 'Container'}</p>
                                    <p>AskAries available: {window.AskAries ? 'Yes' : 'No'}</p>
                                    <p>AskAries mounted: {window.AskAries?.mountCheck?.() ? 'Yes' : 'No'}</p>
                                    {loadingStep && <p>Loading step: {loadingStep}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }

    // Widget mode rendering
    return (
        <div>
            {!isLoaded && !error && (
                <div className='flex h-full items-center justify-center'>
                    <div className='text-center'>
                        <div className='border-slate-200 border-t-slate-600 mb-4 inline-block h-12 w-12 animate-spin rounded-full border-4'></div>
                        <div className='text-gray-600'>
                            <p className='font-medium'>Loading Aries in Widget mode...</p>
                            <p className='mt-2 text-sm text-gray-500'>
                                {loadingStep || 'Please wait while the application loads as a widget'}
                            </p>
                        </div>
                    </div>
                </div>
            )}
            {error && (
                <div className='bg-gray-100 mt-4 rounded-md p-4'>
                    <div className='flex'>
                        <div className='text-gray-700 text-sm'>
                            <p className='font-bold'>Error loading micro-frontend</p>
                            <p>{error}</p>
                            {loadingStep && <p className='text-xs mt-1'>Step: {loadingStep}</p>}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};